/* What the viewer and an answer share about files, with no libraries behind it: which
   extensions are pictures, and saving bytes or an address. */

export const IMAGE = /^(png|jpe?g|gif|webp|svg|avif|bmp|ico)$/;

export function saveBlob(blob: Blob, name: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = name; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

/** Downloads what an address points at, under `name` (a page of its own when the browser
    won't save across origins). */
export function downloadUrl(url: string, name: string) {
  const link = document.createElement("a");
  link.href = url; link.download = name; link.rel = "noopener noreferrer"; link.target = "_blank"; link.click();
}
